import React, { Component } from "react";
import { Growl } from "primereact/growl";
import { Textbox, Textarea } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";

import { AutoComplete } from "primereact/autocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import addMonths from "date-fns/addMonths";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Dropdown } from "primereact/dropdown";

class HomeCarePlanList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pno: "",
      name: "",
      nameSuggestions: null,
      nameList: [],
      date: "",
      type: "",
      listClass: "collapse",
      list: [],
      types: [
        { label: "Doctor", value: "Doctor" },
        { label: "Emergency", value: "Emergency" },
        { label: "Nurse", value: "Nurse" },
        { label: "Volunteer", value: "Volunteer" }
      ],
      type: ""
    };

  }

  componentDidMount() {
    this.LoadNames();


    if (this.props.pno !== "") {
      this.LoadData(this.props.pno);
      this.setState({ name: this.props.name, pno: this.props.pno });
    }
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/patient/getNames"
      )
      .then((response) => {
        this.setState({ patientList: response.data });
        let nameData = response.data;
        nameData.forEach(function (item) {
          _nameList.push("[" + item.pno + "] " + item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter((t) => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  render() {
    return (
      <div>
        <div>
          <h3 align="center">Home Care</h3>
        </div>
        <div className="container-fluid" >
          <div className="row p-1 border">
            <div className="col col-md-1">Patient</div>
            <div className="col col-md-3">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={34}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-1">Date</div>
            <div className="col col-md-2">
              <DatePicker
                selected={this.state.date}
                onChange={(e) => this.setState({ date: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 6)}
                maxDate={addMonths(new Date(), 6)}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-1">Type</div>
            <div className="col col-md-2">
              <Dropdown
                value={this.state.type}
                options={this.state.types}
                placeholder="Select Type"
                onChange={e => this.setState({ type: e.target.value })}
                style={{ width: "270px" }}
              />
            </div>
          </div>
          <div className="row p-1 border">
            <button
              onClick={this.onSaveClick}
              className="btn btn-primary btn-md mr-2"
            >
              Save
            </button>

          </div>

          <div className={this.state.listClass}>
            <div
              className="col col-md-12 ag-theme-blue"
              style={this.getHeight()}
            >
              <AgGridReact
                rowData={this.state.list}
                pagination={true}
                enableSorting={true}
                enableFilter={true}
                onGridReady={this.onGridReady}
                paginationAutoPageSize={true}
              >
                <AgGridColumn field="_id" hide="true" />

                <AgGridColumn
                  field="type"
                  headerName="Type"
                  width={200}
                  sortable
                  resizable
                  filter
                />
                <AgGridColumn
                  field="date"
                  headerName="Date"
                  width={200}
                  sortable
                  resizable
                  filter
                  valueFormatter={this.dateFormatter}
                />

                <AgGridColumn
                  width={130}
                  headerName="Update"
                  cellRendererFramework={this.renderButton}
                />
              </AgGridReact>
            </div>
          </div>

          <Growl ref={(el) => (this.growl = el)} />
        </div>
      </div>
    );
  }

  renderButton = params => {
    return (
      <p>
        <a
          onClick={this.onUpdateClick}
          className="text-primary"
          data={JSON.stringify(params.data)}
        >
          Click Here
        </a>
      </p>
    );
  };

  onUpdateClick = async e => {

    this.props.onClick(
      "Edit",
      JSON.parse(e.target.getAttribute("data")),
      this.state.pno,
      this.state.name
    );
  };

  getHeight() {
    var hgt = window.innerHeight - 275;
    return { height: hgt + "px" };
  }


  dateFormatter(params) {
    if (params.value !== null && params.value !== "") {
      var arr = params.value.split("-");
      return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
    }
  }

  onNameSelect = (e) => {

    let p = e.value.split("] ");
    let pno = p[0].replace("[", "");

    let results = this.state.patientList.filter((t) => {
      return t.pno.toLowerCase() === pno.toLowerCase();
    })[0];

    this.setState({
      pno: pno
    });

    this.LoadData(pno);

  };

  LoadData(pno) {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/homeCarePlan/" +
        pno.replace("/", "-")
      )
      .then(response => {
        this.setState({
          listClass: "row p-1 border",
          list: response.data
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  onNameChange = (e) => {
    this.Clear();
    this.setState({
      name: e.value,
      listClass: "collapse",
      list: []
    });
  };

  Clear() {
    this.setState({
      date: null,
      type: ""
    });
  }


  onSaveClick = e => {
    e.preventDefault();

    if (
      this.state.pno === "" ||
      this.state.type === "" ||
      this.state.date === null) {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Input  !!"
      });
    } else {
      let pat = this.state.name.split("] ");
      let obj = {
        pno: this.state.pno,
        date: this.state.date,
        type: this.state.type,
        name : pat[1]
      };

      axios
        .post(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/patient/homeCarePlan/",
          obj
        )
        .then(res => {
          this.Clear();
          this.LoadData(this.state.pno);
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Details Updated !!!"
          });
        });
    }
  };

}

export default HomeCarePlanList;
